const Layout = () => import('@/layout/index.vue');

export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
      showLink: false,
      rank: 101
    }
  },
  {
    path: '/redirect',
    component: Layout,
    meta: {
      icon: 'homeFilled',
      title: '首页看板',
      showLink: false,
      rank: 104
    },
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/layout/redirect.vue')
      }
    ]
  },
  {
    path: '/:error*', // /:error -> 匹配 /, /one, /one/two, /one/two/three, 等
    name: '404',
    component: () => import('@/views/error/404.vue')
  }
] as Array<RouteConfigsTable>;
